import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import './media-control-bar.css'

export type MediaControlBarKind = 'audio' | 'video'
export type MediaControlBarLayout = 'default' | 'legacy-header' | 'legacy-progress'

export interface MediaControlBarProps extends ComponentPropsWithoutRef<'div'> {
  readonly children: ReactNode
  readonly kind: MediaControlBarKind
  readonly layout?: MediaControlBarLayout
}

export function MediaControlBar({
  children,
  className = '',
  kind,
  layout = 'default',
  ...props
}: MediaControlBarProps) {
  const classes = ['lmsMediaControlBar', `lmsMediaControlBar-${kind}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      {...props}
      className={classes}
      data-media-kind={kind}
      data-media-layout={layout}
      data-slot="media-control-bar"
    >
      {children}
    </div>
  )
}
